import { createSlice } from "@reduxjs/toolkit";
import {
  dataTableActions,
  resetDataTableActions,
  setFiltersDataTableActions,
} from "../../actions/dataTable/DataTableAsyncActions";
import { logOut } from "../layout";

export type SharedDataState = {
  actions: any[];

  loading: {
    actions: boolean;
    allDataResults: boolean;
  };
  error: {
    actions: string;
    allDataResults: string;
  };

  DataTableOptions: {
    page: number;
    rowOptions: number;
    totalRows: number | null;
  };
};

const initialState: SharedDataState = {
  actions: [],

  loading: {
    actions: false,
    allDataResults: false,
  },
  error: {
    actions: "",
    allDataResults: "",
  },

  DataTableOptions: {
    page: 0,
    rowOptions: 100,
    totalRows: null,
  },
};

const SharedDataSlice = createSlice({
  name: "sharedData",
  initialState: initialState,
  reducers: {
    setActions: (state, action) => {
      state.actions = action.payload;
    },
    setTableDataOptions(state, action) {
      return {
        ...state,
        DataTableOptions: action.payload,
      };
    },
  },
  extraReducers: (builder) => {
    // Actions data
    builder
      .addCase(dataTableActions.pending, (state) => {
        state.loading.actions = true;
        state.error.actions = "";
      })
      .addCase(dataTableActions.fulfilled, (state, action) => {
        state.loading.actions = false;
        const payload = action.payload as {
          total: number | null;
          limit: number;
          data: any[];
        };
        state.actions = payload.data ?? [];
        state.DataTableOptions = {
          ...state.DataTableOptions,
          totalRows: payload.total,
          rowOptions: payload.limit,
        };
      })

      .addCase(dataTableActions.rejected, (state, action) => {
        state.loading.actions = false;
        state.DataTableOptions = initialState.DataTableOptions;
        state.error.actions = action.payload as string;
      });

    builder
      .addCase(resetDataTableActions.pending, (state) => {
        state.loading.actions = true;
        state.error.actions = "";
      })
      .addCase(resetDataTableActions.fulfilled, (state, action) => {
        state.loading.actions = false;

        const payload = action.payload as {
          total: number | null;
          limit: number;
          data: any[];
        };
        state.actions = payload.data ?? [];
        state.DataTableOptions = {
          ...state.DataTableOptions,
          totalRows: payload.total,
          rowOptions: payload.limit,
        };
      })
      .addCase(resetDataTableActions.rejected, (state, action) => {
        state.loading.actions = false;
        state.actions = [];
        state.error.actions = action.payload as string;
      });

    builder
      .addCase(setFiltersDataTableActions.pending, (state) => {
        state.loading.actions = true;
        state.error.actions = "";
      })
      .addCase(setFiltersDataTableActions.fulfilled, (state, action) => {
        state.loading.actions = false;
        const payload = action.payload as {
          total: number | null;
          limit: number;
          data: any[];
        };
        state.actions = payload.data ?? [];
        state.DataTableOptions = {
          ...state.DataTableOptions,
          totalRows: payload.total,
          rowOptions: payload.limit,
        };
      })
      .addCase(setFiltersDataTableActions.rejected, (state, action) => {
        state.loading.actions = false;
        state.actions = [];
        state.error.actions = action.payload as string;
      });

    builder.addCase(logOut, (state) => {
      state.actions = [];
      state.loading = { actions: false, allDataResults: false };
      state.error = { actions: "", allDataResults: "" };
    });
  },
});

export const {
  setActions,
  setTableDataOptions,
  // setActivityChartValue,
  // setAllDataResults,
  // setAllDataResultsLoading,
} = SharedDataSlice.actions;
export const SharedDataReducer = SharedDataSlice.reducer;
